import React, {Component} from 'react';
import {SelectWithSearch} from "./SelectWithSearch";
import { withTranslation } from 'react-i18next';

export const SPECIAL_ITEM_CREATE_AGENCY_CLIENT = "CREATE_AGENCY_CLIENT";
export const SPECIAL_ITEM_GO_TO_AGENCY_CLIENTS_ASSIGMENT = "GO_TO_AGENCY_CLIENTS_ASSIGMENT";

export const getDataBySpecialItem = (t) => ({
    [SPECIAL_ITEM_CREATE_AGENCY_CLIENT]: {
        text: t('agency_client_select.create_new_client'),
        className: "special-item"
    },
    [SPECIAL_ITEM_GO_TO_AGENCY_CLIENTS_ASSIGMENT]: {
        text: t('agency_client_select.go_to_client_assignment'),
        className: "special-item"
    }
});

// Backward compatibility
export const DATA_BY_SPECIAL_ITEM = getDataBySpecialItem;


export class AgencyClientSelectClass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showFormValidationTexts: this.props.showFormValidationTexts
        };

        this.handleSelectedOptionChange = this.handleSelectedOptionChange.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.showFormValidationTexts !== this.props.showFormValidationTexts)
            this.setState({showFormValidationTexts:this.props.showFormValidationTexts});
    }

    componentDidMount() {
        this.setState({
            selectedAccount: this.props.selectedAccount
        })
    }

    getNotSelectableOptions(){
        return [];
    }

    handleSelectedOptionChange(newOption) {
        const selectedAgencyClientId = newOption.id;
        const selectedAgencyClientName = newOption.text.split(" (")[0];

        this.props.onAgencyClientChange(selectedAgencyClientId, selectedAgencyClientName)
    }

    convertAgencyClientsToSelectOptions () {
        if(!this.props.allAgencyClients)
            return [];

        // Vamos a mostrar solo los clientes activos
        return this.props.allAgencyClients.filter((ac) => ac.active).map((agencyClient) => {
            return {
                "id": agencyClient["id"],
                "text": agencyClient["name"] // + (agencyClient.active? "  [NO ACTIVO]" : ""),
            };
        });
    }

    addNewAgencyClientOption(options) {
        const { t } = this.props;
        if(this.props.canCreateNewAgencyClient !== true)
            return;

        const dataBySpecialItem = getDataBySpecialItem(t);
        const newAgencyClientOption = {
            id: SPECIAL_ITEM_CREATE_AGENCY_CLIENT,
            text: dataBySpecialItem[SPECIAL_ITEM_CREATE_AGENCY_CLIENT].text,
            className: dataBySpecialItem[SPECIAL_ITEM_CREATE_AGENCY_CLIENT].className
        };

        if (!this.props.hideGoToAgencyClientsAssignment) {
            const newGoToAgencyClientAssigmentOption = {
                id: SPECIAL_ITEM_GO_TO_AGENCY_CLIENTS_ASSIGMENT,
                text: dataBySpecialItem[SPECIAL_ITEM_GO_TO_AGENCY_CLIENTS_ASSIGMENT].text,
                className: dataBySpecialItem[SPECIAL_ITEM_GO_TO_AGENCY_CLIENTS_ASSIGMENT].className
            };
            options.unshift(newGoToAgencyClientAssigmentOption);
        }

        options.unshift(newAgencyClientOption);

    }

    render() {
        const { t } = this.props;
        if (this.props.loading === true) {
            return <p>{t('common.loading')}</p>
        }
        if (this.props.allAgencyClients !== null) {
            const options = this.convertAgencyClientsToSelectOptions();
            this.addNewAgencyClientOption(options);
            return <SelectWithSearch
                                     optionosNotSelectable={this.getNotSelectableOptions()}
                                     options={options}
                                     selected={this.props.selectedAgencyClient}
                                     onSelectOptionChange={this.handleSelectedOptionChange}
                                     showFormValidationTexts={this.state.showFormValidationTexts}
                                     errorText={t('agency_client_select.must_select_or_create_client')}
            />
        } else {
            return <p>{t('common.loading')}</p>
        }
    }
}

export const AgencyClientSelect = withTranslation()(AgencyClientSelectClass);
export default AgencyClientSelect;
